"use client";

import { useEffect } from "react";

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
      return;
    }

    if (process.env.NODE_ENV === "development") {
      const clearDevCachesAndWorkers = async () => {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map((reg) => reg.unregister()));

          const cacheKeys = await caches.keys();
          await Promise.all(
            cacheKeys
              .filter((key) => key.startsWith("kinofolio-"))
              .map((key) => caches.delete(key))
          );

          console.log("[PWA] Dev mode: service workers unregistered and caches cleared");
        } catch (error) {
          console.error("[PWA] Dev mode cleanup failed:", error);
        }
      };

      void clearDevCachesAndWorkers();
      return;
    }

    const registerSW = async () => {
      try {
        const registration = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
        });

        // Check for updates on page focus
        const checkUpdate = () => registration.update().catch(() => {});
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") checkUpdate();
        });

        // Periodic update check (every 60 minutes)
        setInterval(checkUpdate, 60 * 60 * 1000);

        console.log("[PWA] Service Worker registered successfully");
      } catch (error) {
        console.error("[PWA] Service Worker registration failed:", error);
      }
    };

    // Register after page load to not block rendering
    if (document.readyState === "complete") {
      registerSW();
    } else {
      window.addEventListener("load", registerSW);
      return () => window.removeEventListener("load", registerSW);
    }
  }, []);

  return null;
}
